import React from "react";

/** e.g. 500 FS + 1,000 CC on one line. Reward types map to brand SVG glyphs;
 *  emoji is only a fallback for unknown/user-supplied icons. */
function RewardIcon({ unit, emoji }) {
  const key = String(unit || "").toUpperCase();

  if (key === "FS") {
    // Free spins — circular "spin" arrow, self-contained (no shared <defs>).
    return (
      <svg
        className="rw-ic-svg"
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M20 12a8 8 0 1 1-2.3-5.6" />
        <path d="M20 4v4h-4" />
      </svg>
    );
  }

  if (key === "CC") {
    // Clover Coins — brand four-leaf clover (mirrors #clv in storeSvgDefs).
    return (
      <svg
        className="rw-ic-svg"
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
      >
        <ellipse cx="12" cy="5" rx="3.2" ry="3.8" />
        <ellipse cx="16" cy="9" rx="3.8" ry="3.2" />
        <ellipse cx="12" cy="13" rx="3.2" ry="3.8" />
        <ellipse cx="8" cy="9" rx="3.8" ry="3.2" />
        <rect x="11.4" y="12" width="1.2" height="7" rx=".6" />
      </svg>
    );
  }

  // Fallback: keep whatever icon the payload supplied (emoji / UGC).
  return emoji ? <span aria-hidden="true">{emoji}</span> : null;
}

export default function RewardLine({ rewards, className = "" }) {
  if (!rewards?.length) return null;
  return (
    <span className={`rw-row ${className}`.trim()}>
      {rewards.map((r, idx) => (
        <React.Fragment key={`${r.unit}-${r.amount}-${idx}`}>
          {idx > 0 && <span className="plus">+</span>}
          <span className="rw-line">
            <span className="ic">
              <RewardIcon unit={r.unit} emoji={r.icon} />
            </span>
            {r.amount}
            <span className="u">{r.unit}</span>
          </span>
        </React.Fragment>
      ))}
    </span>
  );
}
